import { useCallback, useEffect, useState } from 'react';
import { getOverview } from '../services/apiService.ts';
import type { SuperOverview } from '../types/overview.ts';

export const useOverview = () => {
  const [data, setData] = useState<SuperOverview | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const next = await getOverview();
      setData(next);
    } catch (err: any) {
      setError(err?.response?.data?.message || err?.message || 'Failed to load overview');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { data, loading, error, refresh };
};
